export const DEFAULT_HEADERS = { "Content-Type": "application/json" };
